var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-field-loader"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":"","pulse":"","size":"1x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }